import React from 'react';
import './RTFilteredTable.css';

/**
 * Combines RTFilters and Table in one card. Shows loading state in the table
 * section only so filters stay visible and interactive.
 *
 * @param {Object} props
 * @param {React.ReactNode} props.filters - RTFilters element
 * @param {React.ReactElement} props.children - Table element
 * @param {boolean} [props.loading]
 * @param {string} [props.loadingMessage]
 * @param {string} [props.className]
 */
const RTFilteredTable = ({
  filters,
  children,
  loading = false,
  loadingMessage = 'Loading...',
  className = '',
}) => (
  <div className={`rt-filtered-table${className ? ` ${className}` : ''}`}>
    {filters}
    {React.isValidElement(children)
      ? React.cloneElement(children, { loading, loadingMessage })
      : children}
  </div>
);

export default RTFilteredTable;
